import { FeatureCollection, GeoJsonProperties, MultiPolygon } from 'geojson';
import { memo } from 'react';
import { Layer, Source } from 'react-map-gl';

export const parcellesFillLayerId = (campaignId: number) =>
  `parcelles-${campaignId}-fill`;

export const parcellesOutlineLayerId = (campaignId: number) =>
  `parcelles-${campaignId}-outline`;

export const LINE_DASH_PATTERNS: number[][] = [
  [1, 0],
  [4, 2],
  [2, 2],
  [6, 2, 2, 2],
  [8, 3],
];

export interface ContractParcellesLayerProps {
  data: FeatureCollection<MultiPolygon, GeoJsonProperties>;
  campaignId: number;
  color: string;
  dashPatternIndex?: number;
  fillOpacity?: number;
  lineOpacity?: number;
  lineWidth?: number;
}

export const ContractParcellesLayer = memo(function ContractParcellesLayer({
  data,
  campaignId,
  color,
  dashPatternIndex = 0,
  fillOpacity = 0.4,
  lineOpacity = 0.9,
  lineWidth = 3,
}: ContractParcellesLayerProps) {
  const sourceId = `parcelles-${campaignId}-source`;
  const fillLayerId = parcellesFillLayerId(campaignId);
  const outlineLayerId = parcellesOutlineLayerId(campaignId);
  const dashPattern = LINE_DASH_PATTERNS[dashPatternIndex % LINE_DASH_PATTERNS.length];

  return (
    <Source data={data} id={sourceId} type="geojson">
      <Layer
        id={fillLayerId}
        paint={{
          'fill-color': color,
          'fill-opacity': fillOpacity,
        }}
        type="fill"
      />
      <Layer
        id={outlineLayerId}
        paint={{
          'line-color': color,
          'line-dasharray': dashPattern,
          'line-opacity': lineOpacity,
          'line-width': lineWidth,
        }}
        type="line"
      />
    </Source>
  );
});
